import { makeStyles } from '@material-ui/core';

const errorFontObj = {
  color: '#000000',
  fontFamily: 'Cabin',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '28px',
};

const errorBlockObj = {
  backgroundColor: '#f2c8c5',
  padding: '8px 16px',
  borderRadius: '3px',
  listStyle: 'none',
};

const useErrorStyles = makeStyles(() => ({
  errorFont: {
    ...errorFontObj,
    '&.MuiFormHelperText-root': {
      ...errorFontObj,
    },
  },
  errorBlock: {
    ...errorBlockObj,
    '&.MuiFormHelperText-root': {
      ...errorBlockObj,
    },
  },
}));

export { useErrorStyles };
